import * as $ from "jquery";
import * as GC from '../../grapecity';
import { Spread } from "../../grapecity";
import * as SPIRIT from "../../SPIRIT";
import *  as _ from "lodash";


//TODO MODALの基盤はのちに改修!!(ライフサイクル、メソッド名,Promiseモデルの採用)

/**
 * 
 * 
 */
export abstract class ModalBase {

    //
    static readonly DATA_KEY = 'SPIRIT';
    //
    static readonly DATA_ATTR = 'data-spirit-modal';
    //
    static readonly INSTANCE_RETAINER = '[' + ModalBase.DATA_ATTR + ']';

    static readonly CLASS_DO_NOT_RELEASE = 'modal-do-not-release';



    /**
    * modalのインスタンス
    */
    protected modal: GC.wjcInput.Popup = null;
    //protected modal: any = null;

    /**
     * コントロールをホストするDOM要素、またはホスト要素のCSS セレクター（例: '#theCtrl'）。
     */
    //protected content: Element | string = null;
    protected content: any = null;

    /**
     *
     */
    protected options: any = null;

    /**
     * 
     */
    protected static readonly defaultOption = {
        isDraggable: true,
        showTrigger: GC.wjcInput.PopupTrigger.None,
        hideTrigger: GC.wjcInput.PopupTrigger.None,
    };

    /**
     */
    protected promise: Promise<unknown>;

    /** */
    get runPromise() {
        return this.promise ?? new Promise((rs, rj) => rs());
    }

    /**
     */
    protected _IsInitialized: boolean = false;

    /**
     * ESCでcloseしまう動作をキャンセル
     */
    public cancelESCKeyClose: boolean;

    /**
     */
    get isShow() {
        return this.modal?.isVisible;
    }


    /**
     * 初期化終了(エラーがあっても終了したらTrue)
     */
    public get IsInitialized() {
        return this._IsInitialized;
    }

    /**
     * 初期化中
     * （this._IsInitialized == false;の場合）
     */
    public get IsInitializing() {
        return this._IsInitialized == false;
    }

    /**
     * 表示中
     */
    public get showing() {
        return this.modal?.showing;
    }

    /**/
    protected _isAbort = false;
    /**
     * 初期失敗
     */
    public get isAbort() {
        return this._isAbort;
    }

    /**
     * 編集されたかどうか
     */
    public isEdited = false;

    /**
     * dialogResult
     */
    public get dialogResult(): any {
        //if (this.modal.dialogResult) {
        //    if (this.modal.dialogResult == 'wj-hide-ok') {
        //        return 'ok';
        //    } else if (this.modal.dialogResult == 'wj-hide-no') {
        //        return 'no';
        //    } else if (this.modal.dialogResult == 'wj-hide-cancel') {
        //        return 'cancel';
        //    }
        //}
        return this.modal.dialogResult;
    }

    /**
     * 準備完了(外部ハントリング用のイベント)
     * 初期化失敗時にはisAbortがTureである
     */
    public onCompleted: (Popup: ModalBase, isAbort: boolean) => void;

    /**
      * show前のイベント
      */
    public onShow: (Popup: ModalBase, CancelEventArgs: GC.wijmo.CancelEventArgs) => boolean = null;

    /**
     * show後のイベント
     */
    public onShown: (Popup: ModalBase, EventArgs: GC.wijmo.EventArgs) => void = null;

    /**
     * close前のイベント
     */
    public onClose: (Popup: ModalBase, CancelEventArgs: GC.wijmo.CancelEventArgs) => boolean = null;

    /**
     * close後のイベント
     */
    public onClosed: (Popup: ModalBase, EventArgs: GC.wijmo.EventArgs) => void = null;


    /**
     * 
     * @param options
     * @param doRun
     */
    constructor(options?: any, doRun = true, cancelESCKeyClose = false) {
        this.options = options;
        //子クラス独自のコンストラクタパラメータがある場合に困ることになるだろう！
        //その場合は子クラスのコンストラクタにて,doRun＝falsにして、当コンストラクタを呼び、
        this.cancelESCKeyClose = cancelESCKeyClose;
        if (doRun) {
            this.run();
        }
    }

    /**
     * 
     */
    public run() {

        this.promise = new Promise((resolve, reject) => {
            console.log('1 : Modal initialize Start!!');
            this._IsInitialized = false;
            resolve();
        }).then(() => {

            return new Promise((resolve, reject) => {
                console.log('2 : initialize!!');
                this.initialize(resolve, reject);
            });
        }).then(($contents) => {
            this.content = $contents;
            return new Promise((resolve, reject) => {
                console.log('3 : initializePopUp!!');
                this.initializePopUp(resolve, reject);
            });
        }).then(() => {
            //TODO [Just in case!!]--今後の状況を見て、下記の存在価値は評価する
            //インスタンス生成とともに、表示しようとした際にDOMが無いとよろしくないので、
            //内部処理なしで、DOMReadyを保証はしておく
            return new Promise((resolve, reject) => {
                $(() => {
                    console.log('XX : DOM created!! ');
                    resolve();
                });
            });

        }).then(() => {
            return new Promise((resolve, reject) => {
                console.log('4 : build!!');
                this.build(resolve, reject);
            });
        }).then(() => {
            return new Promise((resolve, reject) => {
                console.log('5 : setEvent!!');
                this.setEvent(resolve, reject);
            });
        }).then(() => {
            console.log('6 : initialize end!!');
            //return new Promise((resolve, reject) => {
            //});

        }).catch((ex) => {
            this._isAbort = true;
            //TODO system Error
            //common process
            console.log('Error!!');
            if (ex instanceof Error) {
                console.log(ex.message);
            } else {
                console.log(ex);
            }

        }).finally(() => {
            //インスタンスを保持する
            this.retainInstance();
            this._IsInitialized = true;

            console.log('7 : completed');
            //準備完了
            this.completedFork();

            console.log('--------------------------');
            console.log('8 : deffereLoad!!');
            new Promise((resolve, reject) => {
                this.deffereLoad(resolve, reject);
            }).catch((ex) => {
                console.log('deffereLoad　Error!!');
                if (ex instanceof Error) {
                    console.log(ex.message);
                } else {
                    console.log(ex);
                }
            });

        });

    }

    /**
     * コンテントの生成を行うレイアウトのみ（レイアウトデータ取得の為の通信や大枠のDOMを生成する）
     * @param resolve
     * @param reject
     */
    protected abstract async initialize(resolve, reject);
    //protected abstract async initialize(resolve: (content: HTMLElement | JQuery) => void, reject);
    //protected abstract initialize(cb: (elem) => void);

    /**
     * 
     * @param resolve
     * @param reject
     */
    protected initializePopUp(resolve, reject) {
        //protected initializePopUp() {

        //#7863 hideTriggerをBlurに設定すると（モバイルだと特に）
        //意図しないタイミングでモーダルが閉じられてしまうので、（モーダル上にwijmo部品がある場合）
        //wiijmoのBlurの代わりに'ClickBackdrop'を新設し、backdropのクリック(タップ)にてモーダルを閉じるようにする
        let clickBackdrop: boolean;
        //if (SPIRIT.util.userAgent.isMobile() && this.options?.hideTrigger == 'Blur' || this.options?.hideTrigger == GC.wjcInput.PopupTrigger.Blur) {
        if (this.options?.hideTrigger == 'ClickBackdrop' || this.options?.hideTrigger == GC.wjcInput.PopupTrigger.Blur) {
            clickBackdrop = true;
            this.options.hideTrigger = ModalBase.defaultOption.hideTrigger;
        }
        //}

        //イベントFork
        const events = {
            showing: (p: GC.wjcInput.Popup, e: GC.wijmo.CancelEventArgs) => {
                let ret = true;
                if (this.onShow) {
                    ret = this.onShow.call(this, this, e);
                    ret = (ret) ? e.cancel : ret;
                }
                return ret;
            },

            shown: (p: GC.wjcInput.Popup, e: GC.wijmo.EventArgs) => {
                //#3370 
                this.bodyOverflowControl(true);

                //#7863 hideTriggerがBlurに設定すると（モバイルだと特に）
                //意図しないタイミングでモーダルが閉じられてしまうので、
                //wiijmoの
                if (clickBackdrop) {
                    const bkDrop: HTMLElement = (this.modal as any)._bkDrop;
                    if (bkDrop) {
                        const handler = (t) => {
                            t.preventDefault();
                            t.stopPropagation();
                            this.modal.hostElement.focus();
                            this.modal.hide();
                        };
                        bkDrop.removeEventListener("mousedown", handler);
                        bkDrop.addEventListener("mousedown", handler);
                    }
                }

                this.onShown?.call(this, this, e);
            },

            hiding: (p: GC.wjcInput.Popup, e: GC.wijmo.CancelEventArgs) => {
                //編集未確定確認
                SPIRIT.business.page.confirmCloseModal((result) => {
                    //
                    if (result === "ok") {
                        let ret = true;
                        if (this.onClose) {
                            ret = this.onClose.call(this, this, e);
                            //ret = (ret) ? e.cancel : ret;
                            ////falseが帰ってきたらキャンセルする
                            //e.cancel = (ret === false) ? true : false;

                            //キャンセルがfalse
                            if (e.cancel === false) {
                                //falseが帰ってきたらキャンセルする（戻り値優先）
                                e.cancel = (ret === false) ? true : false;
                            }

                        }
                        //return ret;
                    } else {
                        //閉じない
                        //return e.cancel = true;
                        e.cancel = true;
                    }
                }, this);
            },

            hidden: (p: GC.wjcInput.Popup, e: GC.wijmo.EventArgs) => {
                //#3370 
                this.bodyOverflowControl(false);

                this.onClosed?.call(this, this, e);
            }
        }

        //念のためjquery変換
        this.content = $(this.content);
        //#2587 閉じれないモーダル(dissmissがない)で、ESCkey押下で閉じれてしまう
        //escKeyキャンセラーのバインド
        this.escapeKeyCanceler();

        //デフォルトでは、showTrigger プロパティはPopupTrigger.ClickOwner に設定されており、 オーナー要素をクリックすると、ポップアップが表示されます。
        //showTrigger プロパティをPopupTrigger.None に設定すると、 ポップアップはshow メソッドを呼び出すのみで表示されます。
        //loadsh(_.defaults)を使用する場合は,引数の順序が逆になるので注意が必要です
        //const _options = jQuery.extend(true, {}, ModalBase.defaultOption, this.options);

        // #3071 モーダル内のコンテンツが長い場合にモーダルフッターが表示されない
        // モバイルでモーダルを移動することは現実的に厳しいので一旦移動できないようにする
        if (SPIRIT.util.userAgent.isMobile()) {
            ModalBase.defaultOption.isDraggable = false;

            //#3349 スクロール出来ないくなってしまうので有効にする
            //// モーダルbody内でのスクロールを一旦できないようにする
            //// どうやらiPhone(safari)と相性が悪い！！！wijmoも関係してそうな気はするが。。。
            //this.content.removeClass('modal-dialog-scrollable');
        }

        const _options = jQuery.extend(true, {}, ModalBase.defaultOption, this.options, events);
        // create forms
        this.modal = new GC.wjcInput.Popup(this.content, _options);


        resolve();
    }

    /**
     * PopUp中のコンテンツ（initializeCententで生成したcontainer）の実際の中身のインスタンス化及び生成
     * @param resolve
     * @param reject
     */
    protected abstract build(resolve, reject);
    //protected abstract build();


    /**
     * イベントのバインド等を行える
     * @param resolve
     * @param reject
     */
    protected setEvent(resolve, reject) {
        //protected setEvent() {
        $.noop();
        resolve();
    }

    /**
     * 遅延処理などを実行する
     * 画面のメインの制御とは関係しない、MashUpコンテンツ等ののレンダリングに使用する
     * 全てのライフサイクルが最後に実施されます
     * @description
     * @override
     * @param resolve
     * @param reject
     */
    protected deffereLoad(resolve, reject) {
        resolve();
    }

    /**
    * 準備完了
    */
    private completedFork() {
        //準備完了
        this.completed();
        // 準備完了(外部ハントリング用のイベント)
        if (this.onCompleted) {
            this.onCompleted(this, this.isAbort);
        }
    };

    /**
    * 準備完了
    */
    protected completed() { };

    /**
     * インスタンスを保持する
     */
    retainInstance() {
        //コンテンツに識別用属性をつける
        this.content?.attr(ModalBase.DATA_ATTR, '');
        //let RETAINER: JQuery<any> = $(ModalBase.INSTANCE_RETAINER);
        let RETAINER: JQuery<any> = this.content;
        if (RETAINER.length == 0) {
            RETAINER = $(document);
        }
        RETAINER.data(ModalBase.DATA_KEY, this);
    }

    /**
     * @description  
     */
    destroy() {
        //#4468
        //let RETAINER: JQuery<any> = $(ModalBase.INSTANCE_RETAINER);
        let RETAINER: JQuery<any> = this.content;
        if (RETAINER.length == 0) {
            RETAINER = $(document);
        }
        this.close(null);
        RETAINER.data(ModalBase.DATA_KEY, null);
    }

    /**
     * 
     * @param modalFlag モーダルフラグ
     */
    show(modalFlag?) {
        if (this.isAbort) { return; }
        if (this.modal && this.content && this.IsInitialized) {
            if (modalFlag === false) {
                // falseの場合、モーダレス
                this.modal.show(false);
            } else {
                this.modal.show(true);
            }
        } else {
            //#1155 準備出来てない場合リトライ
            this.promise.then(() => {
                this.show(modalFlag);
            });
        }
    }

    /**
     * @param dialogResult
     */
    close(dialogResult?: any) {

        this.modal.hide(dialogResult);
    }


    /**
     * escで閉じてしまう動作をキャンセル
     */
    escapeKeyCanceler() {
        $(this.content).on("keydown", (e) => {
            if (e.keyCode == GC.wijmo.Key.Escape) {
                if (this.cancelESCKeyClose) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }
        });
    }

    /**
     * Modal表示条件下においてはBodyのスクロールはしない
     * iosでは、場合によって動作しないかのしれないが、現状は動作しているので入れておく
     * bootstrapでは、Bodyに対してoverflowを制御を掛けるの対し、wijmoはない為 同様の処理を追加
     * @param block
     */
    bodyOverflowControl(blocking) {
        if (blocking) {
            $('body').addClass('modal-open');
        } else {
            //複数モーダルが同時表示される場合があるので、
            //自分以外で表示されているモーダルがある場合はクラスを外さない!
            let $modals = $(ModalBase.INSTANCE_RETAINER);
            let count = 0;
            $modals.each((i, modal) => {
                let ins: ModalBase = $(modal).data(ModalBase.DATA_KEY);
                //#4468
                //if (ins != this) {
                if (ins && ins != this) {
                    if (ins.isShow) {
                        count++;
                    }
                }
            });
            if (count === 0) {
                $('body').removeClass('modal-open');
            }
        }
    }

    /**
     * エラー情報をソートする
     * @param spread
     * @param spreadName
     * @param row
     * @param col
     * @param colName
     * @param messages
     */
    protected sortErrorInfo(spreadInfoList: Array<SPIRIT.interfaces.SpreadInfo>, errorInfoList: Array<SPIRIT.interfaces.IErrorInfo>): Array<SPIRIT.interfaces.IErrorInfo> {

        const spreadOrder = {};

        spreadInfoList.forEach((spreadInfo, index) => {
            spreadOrder[spreadInfo.spreadName] = index;
        });

        // 並び順を指定のSpread > 行 > 列 で並べる
        errorInfoList.sort((a, b) => {

            const spreadOrderA = spreadOrder[a.spreadName];
            const spreadOrderB = spreadOrder[b.spreadName];
            const rowA = a.row;
            const rowB = b.row;
            const colA = a.col;
            const colB = b.col;

            // Spread
            if (spreadOrderA < spreadOrderB) { return -1; }
            if (spreadOrderA > spreadOrderB) { return 1; }

            // 行
            if (rowA < rowB) { return -1; }
            if (rowA > rowB) { return 1; }

            // 列
            if (colA < colB) { return -1; }
            if (colA > colB) { return 1; }

            return 0;

        });

        return errorInfoList;
    }

    /**
     * エラー情報を作成して返却する
     * @param spread
     * @param spreadName
     * @param row
     * @param col
     * @param colName
     * @param messages
     */
    protected createErrorInfo(spread: Spread.Sheets.Workbook, spreadName, row, col, colName, messages): SPIRIT.interfaces.IErrorInfo {
        const errorInfo: SPIRIT.interfaces.IErrorInfo = {
            spread: spread,
            spreadName: spreadName,
            row: row,
            col: col,
            colName: colName,
            messages: messages
        };
        return errorInfo;
    }

    /**
     * 指定されたプロパティの値をtrimする
     * @param array
     * @param targetPropertyNameList
     */
    doTrimValue(array: any[], targetPropertyNameList: string[]) {

        const result = _.cloneDeep(array);

        targetPropertyNameList.forEach((propertyName) => {
            result.forEach((item) => {
                if (item[propertyName]) {
                    item[propertyName] = item[propertyName].trim();
                }
            });
        });

        return result;
    }
}
